module.exports = __webpack_public_path__ + "static/media/09.2f2b392b.mp3";